// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2c4K1","name":"styles_name__3OUqU","phone":"styles_phone__r6I_2"};